import { gql } from "@apollo/client"
import { TierOverviewSectionFragment } from "../../../PartnershipTierOverviewSection/fragment"
import {
    TierFeaturesSectionApplylistFragment,
    TierFeaturesSectionCollectivePassFragment,
} from "../../../PartnershipTierFeaturesSection/fragment"

export const BasePartnershipTierSelectorItemTierFragment = gql`
    fragment BasePartnershipTierSelectorItemTierFragment on CollectivePassType {
        id
        ...TierOverviewSectionFragment
        ...TierFeaturesSectionCollectivePass
    }
    ${TierOverviewSectionFragment}
    ${TierFeaturesSectionCollectivePassFragment}
`

export const BasePartnershipTierSelectorItemApplylistFragment = gql`
    fragment BasePartnershipTierSelectorItemApplylistFragment on ApplylistType {
        id
        canEdit
        ...TierFeaturesSectionApplylist
    }
    ${TierFeaturesSectionApplylistFragment}
`
